import { render, staticRenderFns } from "./EditBrandingDetail.vue?vue&type=template&id=4f81865a&scoped=true&"
import script from "./EditBrandingDetail.vue?vue&type=script&lang=js&"
export * from "./EditBrandingDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditBrandingDetail.vue?vue&type=style&index=0&id=4f81865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81865a",
  null
  
)

export default component.exports